/**
 * engine API
 * engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {Resource} from '../model/resource';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class EnginePublicDownloadService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param token 
     * @param groupe 
     * @param partner 
     * @param displayMode 
     * @param columns 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public downloadSaveQuery1(token: string, groupe: string, partner: string, displayMode: string, columns?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public downloadSaveQuery1(token: string, groupe: string, partner: string, displayMode: string, columns?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public downloadSaveQuery1(token: string, groupe: string, partner: string, displayMode: string, columns?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public downloadSaveQuery1(token: string, groupe: string, partner: string, displayMode: string, columns?: Array<string>, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling downloadSaveQuery1.');
        }

        if (groupe === null || groupe === undefined) {
            throw new Error('Required parameter groupe was null or undefined when calling downloadSaveQuery1.');
        }

        if (partner === null || partner === undefined) {
            throw new Error('Required parameter partner was null or undefined when calling downloadSaveQuery1.');
        }

        if (displayMode === null || displayMode === undefined) {
            throw new Error('Required parameter displayMode was null or undefined when calling downloadSaveQuery1.');
        }


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }
        if (groupe !== undefined && groupe !== null) {
            queryParameters = queryParameters.set('groupe', <any>groupe);
        }
        if (partner !== undefined && partner !== null) {
            queryParameters = queryParameters.set('partner', <any>partner);
        }
        if (columns) {
            columns.forEach((element) => {
                queryParameters = queryParameters.append('columns', <any>element);
            })
        }
        if (displayMode !== undefined && displayMode !== null) {
            queryParameters = queryParameters.set('displayMode', <any>displayMode);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/csv; charset=utf-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Blob>('get', `${this.basePath}/api/public/v1/download/save-query/csv`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
